import { useTranslation } from 'react-i18next';

import { useAuthStore } from '@/shared/auth/auth-store';

const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur']);

export function useLocale() {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const rtl = RTL_LANGS.has(locale);

  const change = async (lng: string) => {
    await i18n.changeLanguage(lng);
    const isRtl = RTL_LANGS.has(lng);
    document.documentElement.lang = lng;
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    useAuthStore.getState().setLocale(lng, isRtl);
  };

  return { locale, rtl, change };
}
